import { render, staticRenderFns } from "./ProjectPageUnassignedUserStoryActions.vue?vue&type=template&id=7fc9dc36&scoped=true&"
import script from "./ProjectPageUnassignedUserStoryActions.vue?vue&type=script&lang=js&"
export * from "./ProjectPageUnassignedUserStoryActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc9dc36",
  null
  
)

export default component.exports